import { Col, Row } from "antd";
import { Moment } from "moment";

import BoxSectionItem from "../../../../../../../components/box-section/box-section-item";
import { DateHelper, StringHelper } from "../../../../../../../helper";
import { DateFormat, Position, PositionCode, titleGroups } from "../../../../../../../constants";
import { isInGroup } from "../../../pages/absence-letter/absence-letter-create";

interface Props {
  data: any;
}

export const ApplicationForLeaveDetail = ({ data }: Props) => {
  const title = StringHelper.verticalBarSplit<[Position]>(data?.eTitle)[0];
  const isHeadDep = isInGroup(title, [PositionCode.TP, PositionCode.TTT, PositionCode.GD]);
  const isDirector = isInGroup(title, [PositionCode.GD]);
  const isTitleGroup8 = isInGroup(title, titleGroups.eight);

  const isTSN = ["TSN", "VTSN"].includes(data.eDepartment[0]);
  const isDAD = ["DAD", "VDAD"].includes(StringHelper.verticalBarSplit(data.eDepartment)[0]);

  const eVacationPeriodText = () => {
    return data?.eVacationPeriods
      .map((i: Moment[]) =>
        DateHelper.formatRangeDateToString(i, {
          format: DateFormat.DD_MM_YYYY_HH_MM,
        }),
      )
      .join(", ");
  };

  return (
    <Row gutter={[32, 0]}>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem
          textLeft="Họ và tên người tạo đơn"
          textRight={StringHelper.verticalBarSplit(data?.eCreatedBy)[1]}
        />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Họ và tên" textRight={data?.eRequestName} />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Chức danh" textRight={StringHelper.verticalBarSplit(data?.eTitle)[1]} />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Cơ quan/Đơn vị" textRight={StringHelper.verticalBarSplit(data?.eDepartment)[1]} />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Đơn vị" textRight={StringHelper.verticalBarSplit(data?.eUnit)[1]} />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Đội/Nhóm" textRight={StringHelper.verticalBarSplit<string[]>(data?.eTeam)[1]} />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Email" textRight={data?.eEmail} />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Thời gian xin nghỉ " textRight={eVacationPeriodText()} />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Lần nghỉ phép thứ" textRight={data?.ePaidLeaveTimes} />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Thời gian nghỉ" textRight={DateHelper.duration(data?.eVacationPeriods).humanize()} />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Số ngày phép còn lại" textRight={data?.ePaidLeaveRemain} />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Nơi nghỉ phép" textRight={data?.eLeavePlace} />
      </Col>
      {isDAD && !isTitleGroup8 && (
        <Col span={12} xs={24} lg={12}>
          <BoxSectionItem textLeft="Nghỉ phép nước ngoài" textRight={data?.isOverseas ? "Có" : "Không"} />
        </Col>
      )}
      {((isHeadDep && isTSN) || isDirector || (isDAD && isTitleGroup8)) && (
        <>
          <Col span={12} xs={24} lg={12}>
            <BoxSectionItem textLeft="Giấy ủy quyền số" textRight={data?.eProxyId} />
          </Col>
          <Col span={12} xs={24} lg={12}>
            <BoxSectionItem textLeft="Ủy quyền cho" textRight={data?.eProxyFor} />
          </Col>
        </>
      )}
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Số điện thoại" textRight={data?.ePhone} />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Lý do" textRight={data?.eReason} />
      </Col>
    </Row>
  );
};
